<div style="width: 25px;height: 25px;float: right;position: relative;right: -10px;cursor: pointer;"
     (click)="closeModal()">
  <i class="material-icons icon" style="font-size: 30px;color: #c80000">
    cancel
  </i>
</div>
<mat-dialog-content class="container" novalidate>
  <form [formGroup]="portalUserAddForm">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <mat-form-field class="form-element">
            <input matInput placeholder="Kullanıcı Adı" formControlName="username">
            <mat-error *ngIf="portalUserAddForm.controls['username'].hasError('required')">Kullanıcı adı girmelisiniz</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <mat-form-field>
            <!--<mat-label>Çalışan Listesi</mat-label>
            <mat-select formControlName="employeeId" [(value)]="selectedEmployeeId" (selectionChange)="employeeChange()">
              <mat-option *ngFor="let employee of employees" [value]="employee.id">
                {{employee.name}} {{employee.surname}}
              </mat-option>
            </mat-select>-->
            <input type="text" placeholder="Çalışan Seçiniz" aria-label="Number" matInput
                   formControlName="employee" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)=employeeChange($event)>
              <mat-option *ngFor="let employee of filteredEmployeeList | async" [value]="employee">
                {{employee.fullName}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="portalUserAddForm.controls['employee'].hasError('required') ||
                              portalUserAddForm.controls['employee'].hasError('incorrect')">
              Çalışan Seçiniz
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <mat-form-field class="form-group">
          <mat-label>Rol Listesi</mat-label>
          <mat-select
                      formControlName="roles" required  multiple="multiple">
            <mat-option *ngFor="let role of rolelist" [value]="role.id">
              {{role.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <mat-form-field class="form-element">
            <input matInput placeholder="Email" formControlName="email">
            <mat-error *ngIf="portalUserAddForm.controls['email'].hasError('required')">Email girmelisiniz</mat-error>
            <mat-error *ngIf="portalUserAddForm.controls['email'].hasError('email')">Email formatı hatalı</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <mat-card style="margin-bottom: 10px;">Şifre, tc no olacak şekilde ayarlanmıştır.</mat-card>
      </div>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!portalUserAddForm.valid" (click)="createOrUpdatePortalUser()">Kaydet</button>
  </form>
  <!-- bitis -->
</mat-dialog-content>
<div mat-dialog-actions align="end">
</div>
